import { AccessItems } from './helper';
import getConstants from './constants';

export const canActivatePlan = (
  plan: {
    status: string;
    depositPaymentStatus?: string;
    consentApprovalDate?: string;
    planBlockActivation: boolean;
    applicationStep?: string;
  },
  userAccess: AccessItems,
  bnplRegReformEnabled: boolean
) => {
  const { PLAN_APPROVED_STATUS } = getConstants();

  const planIsApproved = plan.status.toLowerCase() === PLAN_APPROVED_STATUS;
  const planHasDeposit = plan.depositPaymentStatus !== '';
  const hasPermissionToActivate = userAccess.activatePlans || userAccess.administrator;
  const customerHasConsentedToPlan = !!plan.consentApprovalDate || !bnplRegReformEnabled;

  return (
    !plan.planBlockActivation &&
    planIsApproved &&
    planHasDeposit &&
    hasPermissionToActivate &&
    customerHasConsentedToPlan
  );
};
